module.exports = __webpack_public_path__ + "static/footer-left-f61d6ab0daecf7ffd3e71d318d77ed05.png";